import React, { Component } from "react";
import Select from "react-select";
import Switch from "@material-ui/core/Switch";

const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#6F6F6F",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

class VisitaGrupo3 extends Component {
  render() {
    return (
      <>
        <fieldset className="panel">
          <legend>INFORMACIÓN GENERAL</legend>

          <div className="container">
            <div className="row">
              <div className="col-lg-3">
                <div className="form-group">
                  <label htmlFor="fecha_inspeccion">
                    Fecha: <span className="text-danger"> *</span>
                  </label>

                  <input
                    type="date"
                    name="fecha_inspeccion"
                    onChange={(e) =>
                      this.props.component.handleFechaInspeccionChange(e)
                    }
                    id="fecha_inspeccion"
                    value={this.props.state.fecha_inspeccion}
                    className="form-control"
                    placeholder="Fecha"
                  />
                </div>
              </div>
              <div className="col-lg-3">
                <div className="form-group">
                  <label htmlFor="folio_manual">Folio manual: </label>
                  <input
                    type="text"
                    value={
                      this.props.state.folio_manual != null
                        ? this.props.state.folio_manual
                        : ""
                    }
                    maxLength="100"
                    onChange={(e) =>
                      this.props.component.handleFolioManualChange(e)
                    }
                    name="folio_manual"
                    className="form-control"
                    id="folio_manual"
                    placeholder="Folio manual"
                  />
                </div>
              </div>
              <div className="col-lg-3">
                <div className="form-group">
                  <label htmlFor="no_lote">
                    No. Lote: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    name="no_lote"
                    maxLength="100"
                    onChange={this.props.component.handleNoLoteChange}
                    id="no_lote"
                    value={this.props.state.no_lote}
                    className="form-control"
                    placeholder="Número de lote"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="no_lote-error"
                  ></div>
                </div>
              </div>
              <div className="col-lg-2">
                <div className="form-group">
                  <label htmlFor="vol_peso">
                    Vol./Peso: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="number"
                    min="0"
                    max="99999.99"
                    step="0.01"
                    maxLength="100"
                    name="vol_peso"
                    onChange={(e) =>
                      this.props.component.handleVolPesoChange(e)
                    }
                    id="vol_peso"
                    value={this.props.state.vol_peso}
                    className="form-control"
                    placeholder="Ingrese peso"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="vol_peso-error"
                  ></div>
                </div>
              </div>
              <div className="col-lg-1">
                <div className="form-group">
                  <label htmlFor="unidad_medida_vol">
                    Unidad: <span className="text-danger"> *</span>
                  </label>
                  <select
                    name="unidad_medida_vol"
                    id="unidad_medida_vol"
                    className="form-control"
                    disabled
                    value={this.props.state.unidad_medida_vol}
                  >
                    {this.props.state.cat_um.map((um) => (
                      <option key={um.id} value={um.id}>
                        {um.descripcion}
                      </option>
                    ))}
                  </select>
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="unidad_medida_vol-error"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset className="panel">
          <legend>TIPO DE MUESTRA</legend>

          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label htmlFor="tipo_muestra">
                    {this.props.state.tipo_encuesta === "8"
                      ? "Residuos (trazas) de medicamentos y contaminantes: "
                      : "Tipo de muestra: "}
                    <span className="text-danger"> *</span>
                  </label>
                  <Select
                    isMulti={false}
                    id="tipo_muestra"
                    styles={colourStyles}
                    placeholder="Seleccione"
                    onChange={this.props.component.handleTipoMuestraChange}
                    theme="neutral40"
                    value={
                      this.props.state.tipo_muestra !== null ||
                      this.props.state.tipo_muestra !== ""
                        ? this.props.state.tipo_muestra
                        : { label: "Seleccione", key: "0" }
                    }
                    options={this.props.state.cat_tipo_muestra}
                    getOptionLabel={(muestra) =>
                      muestra.descripcion.toUpperCase()
                    }
                    getOptionValue={(muestra) => muestra.id}
                    noOptionsMessage={() =>
                      "No se encontraron más tipos de muestras"
                    }
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="tipo_muestra-error"
                  ></div>
                </div>
              </div>
            </div>

            {this.props.state.tipo_muestra.id === "1" ? (
              <div className="row">
                {this.props.state.producto_fabricante_registrado ? (
                  <>
                    <div className="col-lg-7">
                      <div className="form-group">
                        <label htmlFor="producto_tipo_alimento">
                          Alimento (nombre comercial):{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <Select
                          id="producto_tipo_alimento"
                          styles={colourStyles}
                          placeholder="Seleccione"
                          onChange={
                            this.props.component
                              .handleProductoTipoAlimentoChange
                          }
                          theme="neutral40"
                          options={this.props.state.cat_productos_tipo_alimento}
                          getOptionLabel={(producto) =>
                            producto.producto_nombre
                          }
                          getOptionValue={(producto) => producto.id}
                          noOptionsMessage={() => "No se encontraron alimentos"}
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="producto_tipo_alimento-error"
                        ></div>
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="form-group">
                        <label htmlFor="no_registro">
                          No. Registro: <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          id="no_registro"
                          value={this.props.state.no_registro}
                          className="form-control"
                          readOnly
                          placeholder="Número de registro"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="no_registro-error"
                        ></div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="col-lg-11">
                    <div className="form-group">
                      <label htmlFor="producto_tipo_alimento_texto">
                        Alimento (nombre comercial):{" "}
                        <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Nombre comercial"
                        id="producto_tipo_alimento_texto"
                        onChange={(e) =>
                          this.props.component.handleProductoTipoAlimentoChange(
                            e
                          )
                        }
                        value={this.props.state.producto_tipo_alimento_texto}
                        className="form-control"
                      />
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="producto_tipo_alimento_texto-error"
                      ></div>
                    </div>
                  </div>
                )}

                <div className="col-lg-1">
                  <div className="form-group">
                    <label htmlFor="producto_fabricante_registrado">
                      Registrado:
                    </label>
                    <br />
                    <Switch
                      className="producto_fabricante_registrado"
                      checked={this.props.state.producto_fabricante_registrado}
                      name="producto_fabricante_registrado"
                      onChange={(e) =>
                        this.props.component.handleProductoFabricanteRegistradoChange(
                          e
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            ) : null}

            {this.props.state.tipo_muestra.id === "2" ? (
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <label htmlFor="materia_prima_texto">
                      Materia prima:
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Materia prima"
                      id="materia_prima_texto"
                      onChange={(e) =>
                        this.props.component.handleMateriaPrimaTextoChange(e)
                      }
                      value={
                        this.props.state.materia_prima_texto !== "" ||
                        this.props.state.materia_prima_texto !== null
                          ? this.props.state.materia_prima_texto
                          : ""
                      }
                      className="form-control"
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="materia_prima_texto-error"
                    ></div>
                  </div>
                </div>
              </div>
            ) : this.props.state.tipo_muestra.id === "3" ? (
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <label htmlFor="sales_texto">
                      Sales:
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Sales"
                      id="sales_texto"
                      onChange={(e) =>
                        this.props.component.handleSalTextoChange(e)
                      }
                      value={
                        this.props.state.sales_texto !== "" ||
                        this.props.state.sales_texto !== null
                          ? this.props.state.sales_texto
                          : ""
                      }
                      className="form-control"
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="sales_texto-error"
                    ></div>
                  </div>
                </div>
              </div>
            ) : this.props.state.tipo_muestra.id === "4" ? (
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <label htmlFor="otros_texto">
                      Otros:
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      onChange={(e) =>
                        this.props.component.handleOtroTipoMuestraChange(e)
                      }
                      value={this.props.state.otros_texto}
                      id="otros_texto"
                      className="form-control"
                      placeholder="Otros"
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="otros_texto-error"
                    ></div>
                  </div>
                </div>
              </div>
            ) : null}

            {this.props.state.tipo_muestra.id ? (
              <div className="row">
                <div className="col-lg-4">
                  <div className="form-group">
                    <label htmlFor="forma_farmaceutica_id">
                      Forma de comercialización:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    {this.props.state.producto_fabricante_registrado &&
                    this.props.state.tipo_muestra.id === "1" ? (
                      <input
                        type="text"
                        onChange={(e) =>
                          this.props.component.handleFormaFarmaceuticaChange(e)
                        }
                        id="forma_farmaceutica_id"
                        value={this.props.state.forma_farmaceutica_texto}
                        className="form-control"
                        readOnly
                        placeholder="Forma de comercialización"
                      />
                    ) : (
                      <Select
                        id="forma_farmaceutica_id"
                        isMulti={false}
                        styles={colourStyles}
                        placeholder="Seleccione"
                        onChange={(e) =>
                          this.props.component.handleFormaFarmaceuticaChange(e)
                        }
                        theme="neutral40"
                        value={
                          this.props.state.forma_farmaceutica !== null ||
                          this.props.state.forma_farmaceutica !== ""
                            ? this.props.state.forma_farmaceutica
                            : { label: "Seleccione", key: "0" }
                        }
                        options={this.props.state.cat_forma_farmaceutica}
                        getOptionLabel={(forma) =>
                          forma.descripcion.toUpperCase()
                        }
                        getOptionValue={(forma) => forma.id}
                        noOptionsMessage={() =>
                          "No se encontraron más formas de comercialización"
                        }
                      />
                    )}
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="forma_farmaceutica_id-error"
                    ></div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label htmlFor="tipo_especie">
                      Especie:
                      {/* <span className="text-danger"> *</span> */}
                    </label>
                    <Select
                      id="tipo_especie"
                      isMulti
                      styles={colourStyles}
                      placeholder="Seleccione"
                      onChange={(e) =>
                        this.props.component.handleTipoEspecieChange(e)
                      }
                      theme="neutral40"
                      value={
                        this.props.state.tipo_especie !== null ||
                        this.props.state.tipo_especie !== ""
                          ? this.props.state.tipo_especie
                          : { label: "Seleccione", key: "0" }
                      }
                      options={
                        this.props.state.producto_fabricante_registrado &&
                        !["2", "3", "4"].includes(
                          this.props.state.tipo_muestra.id
                        )
                          ? this.props.state.cat_especies_productos_dosis
                          : this.props.state.cat_especies
                      }
                      getOptionLabel={(especie) =>
                        especie.descripcion.toUpperCase()
                      }
                      getOptionValue={(especie) => especie.id}
                      noOptionsMessage={() => "No se encontraron especies"}
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="tipo_especie-error"
                    ></div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label htmlFor="tipo_especie">
                      Categoría:
                      {/* <span className="text-danger"> *</span> */}
                    </label>
                    <Select
                      isMulti
                      id="tipo_categoria_especie"
                      styles={colourStyles}
                      placeholder="Seleccione"
                      onChange={(e) =>
                        this.props.component.handleCategoriasEspecieChange(e)
                      }
                      theme="neutral40"
                      value={
                        this.props.state.tipo_categoria_especie !== null ||
                        this.props.state.tipo_categoria_especie !== ""
                          ? this.props.state.tipo_categoria_especie
                          : { label: "Seleccione", key: "0" }
                      }
                      options={this.props.state.cat_categorias}
                      getOptionLabel={(categoria) =>
                        `${categoria.descripcion.toUpperCase()} - (${categoria.tipo_especie.toLowerCase()})`
                      }
                      getOptionValue={(categoria) => categoria.id}
                      noOptionsMessage={() =>
                        "No se encontraron más categorías"
                      }
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="tipo_categoria_especie-error"
                    ></div>
                  </div>
                </div>
              </div>
            ) : null}

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label htmlFor="razon_social">
                    Razón social del fabricante:{" "}
                    <span className="text-danger"> *</span>
                  </label>
                  <div className="input-group">
                    {this.props.state.establecimiento_fabricante_registrado ? (
                      <select
                        name="razon_social"
                        id="razon_social"
                        disabled={
                          this.props.state.tipo_muestra.id === "1" &&
                          this.props.state.producto_fabricante_registrado
                            ? true
                            : false
                        }
                        onChange={
                          this.props.component.handleRazonSocialFabricanteChange
                        }
                        value={this.props.state.establecimiento_id}
                        className="form-control"
                      >
                        <option value="" disabled>
                          Seleccione
                        </option>
                        {this.props.state.cat_establecimientos_fabricante_alimento.map(
                          (option) => (
                            <option key={option.id} value={option.id}>
                              {option.razon_social}
                            </option>
                          )
                        )}
                      </select>
                    ) : (
                      <input
                        id="razon_social"
                        onChange={
                          this.props.component.handleRazonSocialTextoChange
                        }
                        placeholder="Razón social del fabricante"
                        className="form-control"
                        value={this.props.state.razon_social}
                        type="text"
                      />
                    )}
                    <div
                      className="input-group-prepend"
                      title={
                        this.props.state.establecimiento_fabricante_registrado
                          ? "Establecimiento registrado"
                          : "Establecimiento NO registrado"
                      }
                    >
                      <div className="input-group-text">
                        <input
                          type="checkbox"
                          id="razon_social_cb"
                          checked={
                            this.props.state
                              .establecimiento_fabricante_registrado
                          }
                          onChange={
                            this.props.component
                              .handleEstablecimientoFabricanteRegistrado
                          }
                          disabled={
                            this.props.state.tipo_muestra.id === "1" &&
                            this.props.state.producto_fabricante_registrado
                              ? true
                              : false
                          }
                        ></input>
                      </div>
                    </div>
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="razon_social-error"
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div
                className={
                  this.props.state.establecimiento_muestra_registrado
                    ? "col-lg-6"
                    : "col-lg-12"
                }
              >
                <div className="form-group">
                  <label htmlFor="razon_social_muestra">
                    Razón social del establecimiento donde se toma la muestra:{" "}
                    <span className="text-danger"> *</span>
                  </label>

                  <div className="input-group">
                    {this.props.state.establecimiento_muestra_registrado ? (
                      <select
                        name="razon_social_muestra"
                        id="razon_social_muestra"
                        onChange={(e) =>
                          this.props.component.handleRazonSocialMuestraChange(e)
                        }
                        value={this.props.state.establecimiento_id_muestra}
                        className="form-control"
                      >
                        <option value="" disabled>
                          Seleccione
                        </option>
                        {this.props.state.cat_establecimientos_alimento.map(
                          (option) => (
                            <option key={option.id} value={option.id}>
                              {option.razon_social.toUpperCase()}
                            </option>
                          )
                        )}
                      </select>
                    ) : (
                      <input
                        id="razon_social_muestra"
                        onChange={(e) =>
                          this.props.component.handleRazonSocialMuestraTextoChange(
                            e
                          )
                        }
                        placeholder="Razón social"
                        className="form-control"
                        value={this.props.state.razon_social_muestra}
                        type="text"
                      />
                    )}
                    <div
                      className="input-group-prepend"
                      title={
                        this.props.state.establecimiento_muestra_registrado
                          ? "Establecimiento registrado"
                          : "Establecimiento NO registrado"
                      }
                    >
                      <div className="input-group-text">
                        <input
                          type="checkbox"
                          id="razon_social_muestra_cb"
                          checked={
                            this.props.state.establecimiento_muestra_registrado
                          }
                          onChange={(e) =>
                            this.props.component.handleEstablecimientoMuestraRegistrado(
                              e
                            )
                          }
                        ></input>
                      </div>
                    </div>
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="razon_social_muestra-error"
                    ></div>
                  </div>
                </div>
              </div>

              {this.props.state.establecimiento_muestra_registrado ? (
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="actividad_id">
                      Actividad del establecimiento donde se toma la muestra:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <div className="input-group">
                      <select
                        name="actividad_id"
                        id="actividad_id"
                        onChange={this.props.component.handleActividadMuestra}
                        value={this.props.state.actividad_id}
                        className="form-control"
                      >
                        <option value="" disabled>
                          Seleccione
                        </option>
                        {this.props.state.cat_actividades.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.descripcion.toUpperCase()}
                          </option>
                        ))}
                      </select>
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="actividad_id-error"
                      ></div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>

            {!this.props.state.establecimiento_muestra_registrado ? (
              <div className="row">
                {this.props.state.locacion_analisis_nacional ? (
                  <>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="departamento">
                          Departamento: <span className="text-danger"> *</span>
                        </label>

                        <select
                          name="departamento_id"
                          id="departamento_id"
                          onChange={(e) =>
                            this.props.component.handleDepartamentoChange(e)
                          }
                          value={
                            this.props.state.departamento_id != null
                              ? this.props.state.departamento_id
                              : ""
                          }
                          className="form-control"
                          placeholder="Seleccione"
                        >
                          <option value="" disabled>
                            Seleccione
                          </option>
                          {this.props.state.locations.departamentos.map((d) => (
                            <option key={d.id} value={d.id}>
                              {d.name.toUpperCase()}
                            </option>
                          ))}
                        </select>
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="departamento_id-error"
                        ></div>
                      </div>
                    </div>
                    <div className="col-lg-5">
                      <div className="form-group">
                        <label htmlFor="municipio_id">
                          Municipio: <span className="text-danger"> *</span>
                        </label>

                        <select
                          name="municipio_id"
                          id="municipio_id"
                          onChange={(e) =>
                            this.props.component.handleMunicipioChange(e)
                          }
                          value={
                            this.props.state.municipio_id != null
                              ? this.props.state.municipio_id
                              : ""
                          }
                          className="form-control"
                          placeholder="Seleccione"
                        >
                          <option value="" disabled>
                            Seleccione
                          </option>
                          {this.props.state.municipios.map((d) => (
                            <option key={d.id} value={d.id}>
                              {d.name.toUpperCase()}
                            </option>
                          ))}
                        </select>
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="municipio_id-error"
                        ></div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="col-lg-11">
                    <div className="form-group">
                      <label htmlFor="pais">
                        País: <span className="text-danger"> *</span>
                      </label>
                      <select
                        name="nombrePais"
                        id="nombrePais"
                        onChange={(e) =>
                          this.props.component.handlePaisChange(e)
                        }
                        value={this.props.state.pais_id}
                        className="form-control"
                      >
                        <option value="" disabled>
                          Seleccione
                        </option>
                        {this.props.state.cat_paises.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="nombrePais-error"
                      ></div>
                    </div>
                  </div>
                )}
                <div className="col-lg-1">
                  <div className="form-group">
                    <label htmlFor="locacion_analisis_nacional">
                      Nacional:
                    </label>
                    <br />
                    <Switch
                      className="locacion_analisis_nacional"
                      checked={this.props.state.locacion_analisis_nacional}
                      name="locacion_analisis_nacional"
                      onChange={(e) =>
                        this.props.component.handleLocacionAnalisisNacional(e)
                      }
                    />
                  </div>
                </div>
              </div>
            ) : null}

            <br />
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  {/* <label>Representante legal: </label>
                <span className="text-danger"> *</span> */}
                  <div
                    id="listaRepresentantes"
                    className={
                      this.props.state.representantes_legales.length > 0
                        ? ""
                        : "hide"
                    }
                  >
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th>Representantes legales</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.state.representantes_legales.map((item) => (
                          <tr key={item.id}>
                            <td>
                              {item.apellido_materno
                                ? `${item.nombres} ${item.apellido_paterno} ${item.apellido_materno}`
                                : `${item.nombres} ${item.apellido_paterno}`}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  {/* <label>Representante legal: </label>
                <span className="text-danger"> *</span> */}
                  <div
                    id="listaRegentes"
                    className={
                      this.props.state.regentes.length > 0 ? "" : "hide"
                    }
                  >
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th>Regentes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.state.regentes.map((item) => (
                          <tr key={item.id}>
                            <td>
                              {item.apellido_materno
                                ? `${item.nombres} ${item.apellido_paterno} ${item.apellido_materno}`
                                : `${item.nombres} ${item.apellido_paterno}`}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset className="panel">
          <legend>INFORMACIÓN SOLICITANTE</legend>

          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="inspectores">
                    Inspector(es): <span className="text-danger"> *</span>
                  </label>
                  <Select
                    isMulti
                    id="inspectores"
                    name="inspectores"
                    styles={colourStyles}
                    placeholder="Seleccione"
                    onChange={(e) =>
                      this.props.component.handleInspectoresChange(e)
                    }
                    value={
                      this.props.state.inspectores !== null ||
                      this.props.state.inspectores !== ""
                        ? this.props.state.inspectores
                        : { label: "Seleccione", key: "0" }
                    }
                    theme="neutral40"
                    options={this.props.state.cat_inspectores}
                    getOptionLabel={(inspector) =>
                      inspector.inspector_nombre.toUpperCase()
                    }
                    getOptionValue={(inspector) => inspector.id}
                    noOptionsMessage={() => "No se encontraron más inspectores"}
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="inspectores-error"
                  ></div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="tipo_motivo_remision">
                    Motivo de remisión: <span className="text-danger"> *</span>
                  </label>
                  <Select
                    isMulti
                    id="tipo_motivo_remision"
                    styles={colourStyles}
                    placeholder="Seleccione"
                    onChange={(e) =>
                      this.props.component.handleTipoMotivoRemisionChange(e)
                    }
                    theme="neutral40"
                    value={
                      this.props.state.tipo_motivo_remision !== null ||
                      this.props.state.tipo_motivo_remision !== ""
                        ? this.props.state.tipo_motivo_remision
                        : { label: "Seleccione", key: "0" }
                    }
                    options={this.props.state.cat_motivo_remision}
                    getOptionLabel={(motivo) =>
                      motivo.descripcion.toUpperCase()
                    }
                    getOptionValue={(motivo) => motivo.id}
                    noOptionsMessage={() =>
                      "No se encontraron más tipos de motivos"
                    }
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="tipo_motivo_remision-error"
                  ></div>
                </div>
              </div>
            </div>

            {this.props.state.otro_motivo_remision ? (
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <label htmlFor="otro_motivo_remision_texto">
                      Especificar motivo de remisión:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      name="otro_motivo_remision_texto"
                      value={
                        this.props.state.otro_motivo_remision_texto != null
                          ? this.props.state.otro_motivo_remision_texto
                          : ""
                      }
                      onChange={(e) =>
                        this.props.component.handleOtroMotivoRemisionChange(e)
                      }
                      className="form-control"
                      id="otro_motivo_remision_texto"
                      placeholder="Especificar motivo"
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="otro_motivo_remision_texto-error"
                    ></div>
                  </div>
                </div>
              </div>
            ) : null}

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="nombre_representante">
                    Nombre del representante del establecimiento:{" "}
                    <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    name="nombre_representante"
                    value={this.props.state.nombre_representante}
                    onChange={(e) =>
                      this.props.component.handleNombreRepresentanteChange(e)
                    }
                    className="form-control"
                    id="nombre_representante"
                    placeholder="Nombre del representante"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="nombre_representante-error"
                  ></div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="nombre_recibe_laboratorio">
                    Nombre receptor en laboratorio:{" "}
                    {/* <span className="text-danger"> *</span> */}
                  </label>
                  <input
                    type="text"
                    name="nombre_recibe_laboratorio"
                    value={this.props.state.nombre_recibe_laboratorio}
                    onChange={(e) =>
                      this.props.component.handleNombreRecibeLaboratorioChange(
                        e
                      )
                    }
                    className="form-control"
                    id="nombre_recibe_laboratorio"
                    placeholder="Nombre receptor del laboratorio"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="nombre_recibe_laboratorio-error"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        {this.props.state.tipo_encuesta === "9" ||
        this.props.state.tipo_encuesta === "10" ? (
          <fieldset className="panel">
            <legend>ANÁLISIS SOLICITADO</legend>

            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <table className="table" width="100%">
                    <thead>
                      <tr>
                        <th colSpan="3">
                          <strong>Análisis solicitado</strong>
                        </th>

                        {/* <th width="60%"></th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.state.cat_analisis_solicitado.map(
                        (analisis) => (
                          <tr key={analisis.id} className="p-0">
                            <td
                              width="5%"
                              style={{ textAlign: "center" }}
                              className="pt-3"
                            >
                              <input
                                className="form-check-input"
                                type="checkbox"
                                onChange={(e) =>
                                  this.props.component.handleAnalisisSolicitadoCBChange(
                                    e
                                  )
                                }
                                id={`analisis_producto_cb-${analisis.id}`}
                              />
                            </td>
                            <td width="35%" className="pt-3">
                              {analisis.descripcion}
                            </td>
                            <td width="60%">
                              <input
                                type="text"
                                id={`analisis_producto_input-${analisis.id}`}
                                readOnly
                                onChange={(e) =>
                                  this.props.component.handleAnalisisSolicitadoChange(
                                    e
                                  )
                                }
                                placeholder="Especificar"
                                className="form-control"
                              />
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>

                  <table className="table" id="tabla_otros" width="100%">
                    <thead>
                      <tr>
                        <th width="35%">
                          <strong>Otros</strong>
                        </th>
                        <th width="65%"></th>
                        <th width="5%">
                          <div className="form-group">
                            <button
                              title="Agregar otro"
                              type="button"
                              onClick={(e) =>
                                this.props.component.addOtroAnalisis(e)
                              }
                              className="btn btn-info float-right"
                            >
                              <i className="fas fa-plus"></i>
                            </button>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody id="tabla_otros_body"></tbody>
                  </table>
                </div>
              </div>
            </div>
          </fieldset>
        ) : null}

        <fieldset className="panel">
          <legend>OBSERVACIONES</legend>

          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <textarea
                    onChange={(e) =>
                      this.props.component.handleObservacionesChange(e)
                    }
                    className="form-control"
                    placeholder="Observaciones"
                    value={this.props.state.observaciones}
                    name="observaciones"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
        {/* <fieldset className="panel">
          <legend>Dictamen de sanción</legend>
          <div className="container">
            <div className="form-group">
              <FormControlLabel
                label="Sancionar establecimiento"
                control={
                  <Checkbox
                    checked={this.props.state.establecimiento_sancionado}
                    onChange={(e) =>
                      this.props.component.handleSancionEstablecimientoCBChange(
                        e
                      )
                    }
                    style={{ color: "#fff" }}
                    name="checkedB"
                    color="primary"
                  />
                }
              />
            </div>
          </div>
        </fieldset> */}

        <hr />
        <button type="submit" className="btn btn-success btn-block">
          Guardar
        </button>
      </>
    );
  }
}

export default VisitaGrupo3;
